var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDocument = function SvgIconDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EADDFF",
    stroke: "#654ACF",
    d: "M.95 23.581V.5h13.554a.5.5 0 0 1 .386.182l5.28 6.403a.5.5 0 0 1 .114.32l-.06 16.176z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C7A5FF",
    stroke: "#654ACF",
    strokeWidth: 0.72,
    d: "M14.904.982a.46.46 0 0 0-.813.294v5.345c0 .484.4.873.883.86l4.28-.116a.46.46 0 0 0 .341-.754z"
  })));
};
export { SvgIconDocument as ReactComponent };